"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridTotalPlugin = void 0;
const react_1 = __importDefault(require("react"));
const GridTotalCellWrapper_1 = require("./components/GridTotalCellWrapper/GridTotalCellWrapper");
const GridTotalRowContainer_1 = require("./components/GridTotalRowContainer/GridTotalRowContainer");
const defaultGridRow_1 = require("../../renderers/defaultGridRow");
function gridTotalPlugin(config) {
    return ({ getColumns }) => {
        const subheaderAddons = [];
        if (config === null || config === void 0 ? void 0 : config.totalRow) {
            subheaderAddons.push({
                id: 'total-row-subheader',
                order: 0,
                render: () => {
                    return (0, defaultGridRow_1.createGridRowRenderer)({
                        container: GridTotalRowContainer_1.GridTotalRowContainer
                    })({
                        index: 0,
                        height: 32,
                        width: 1001,
                        topOffset: 20,
                        getDataByIndex: () => null,
                        columns: getColumns().map((col) => (Object.assign(Object.assign({}, col), { width: col.width || 0, cell: (props) => {
                                var _a, _b;
                                const cell = (_b = (_a = config === null || config === void 0 ? void 0 : config.totalRow) === null || _a === void 0 ? void 0 : _a[col.id]) === null || _b === void 0 ? void 0 : _b.cell;
                                if (!cell) {
                                    return react_1.default.createElement(react_1.default.Fragment, null);
                                }
                                if (col.id === (config === null || config === void 0 ? void 0 : config.totalColumnId)) {
                                    return (react_1.default.createElement(GridTotalCellWrapper_1.GridTotalCellWrapper, { isHighlighted: true }, cell(Object.assign({}, props))));
                                }
                                return cell(props);
                            } }))),
                        className: '',
                        idGetter: () => 'totalRow',
                        style: {},
                        disabled: false,
                        loading: false
                    });
                }
            });
        }
        return {
            subheaderAddons,
            processColumns: (originalColumns) => {
                return originalColumns.map((column) => {
                    return Object.assign(Object.assign({}, column), { header: (props) => {
                            if (column.id === (config === null || config === void 0 ? void 0 : config.totalColumnId)) {
                                return (react_1.default.createElement(GridTotalCellWrapper_1.GridTotalCellWrapper, null, column.header(Object.assign({}, props))));
                            }
                            return column.header(props);
                        }, cell: (props) => {
                            if (column.id === (config === null || config === void 0 ? void 0 : config.totalColumnId)) {
                                return (react_1.default.createElement(GridTotalCellWrapper_1.GridTotalCellWrapper, { isHighlighted: true }, column.cell(Object.assign({}, props))));
                            }
                            return column.cell(props);
                        } });
                });
            }
        };
    };
}
exports.gridTotalPlugin = gridTotalPlugin;
//# sourceMappingURL=gridTotalPlugin.js.map